// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J-Fg-","field":"styles_field__QpvDk","fieldCol":"styles_fieldCol__36xbW","diffCol":"styles_diffCol__3Mc8m","diff":"styles_diff__2OPKO"};